import React from "react";
import Header_Banner from "../common-components/common_banner/header_banner/Header_Banner";
import About_Shore from "./about-shore/About_Shore";
import Meet_Doctor from "./meet-doctor/Meet_Doctor";
import Why_Choose_Shore from "../home/why-choose-shore/Why_Choose_Shore";
import Complete_Medical from "../common-components/common_banner/complete_medical/Complete_Medical";
import Our_Facilities from "./our-facilities/Our_Facilities";
import Our_Services from "../home/our_services/Our_Services";
import Our_Certificates from "./our-certificates/Our_Certificates";

const About_Us = () => {
  const breadcrumbs = [
    { label: "Home", link: "/about-us", isActive: false },
    { label: "ABOUT US", link: "", isActive: true },
  ];
  return (
    <section className="About_Us">
      <Header_Banner
        imgSrc={"assets/images/about_us/healthcare-banner.png"}
        title_text="About Us"
        breadcrumbs={breadcrumbs}
      />

      <About_Shore />
      <Meet_Doctor />
      <Our_Certificates />
      {/* <Our_Services /> */}
      <Our_Facilities />
      <Why_Choose_Shore />
      <Complete_Medical />
    </section>
  );
};

export default About_Us;
